<template>
  <div id="reviewingRecords">
    <div class="remind">
      <i class="icon icon-remind"></i>
      <span class="txt">流程相关操作，请前往PC端！</span>
    </div>
    <div class="box" v-if="detail.length">
      <div class="line"></div>
      <ul class="list">
        <li class="list-item" v-for="(item,index) in detail" :key="index">
          <div class="top">
            <div class="name">
              <span>{{item.content}}</span>
            </div>
            <div class="status">
              {{item.operation}}
            </div>
          </div>
          <div class="bottom">
            <div class="date">
              {{item.createTime}}
            </div>
            <template v-if="item.current">
              <button class="btn" type="button" v-if="item.type === 2">重新投稿</button>
              <button class="btn" type="button" v-else-if="item.uploads">上传授权书</button>
            </template>
          </div>

        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewingRecords',
  data () {
    return {
      id: '',
      detail: [],
      list: [
        { date: '2021-01-01 12:00:00', name: '林老师', status: 1 },
        { date: '2021-01-01 12:00:00', name: '广州出版社', status: 2 },
        { date: '2021-01-01 12:00:00', name: '林老师', status: 3 },
        { date: '2021-01-01 12:00:00', name: '林老师', status: 4 }
      ],
      statusObj: {

      },
      statusList: ['', '进行投稿', '审核中', '待修改', '拟录用'],
      colorList: ['#333333', '#333333', '#5FA9FF', '#FFAF19', '#FF894B']
    };
  },
  mounted () {
    const { $route: { params: { id } } } = this;
    this.id = id;
    this.getDetail();
  },
  methods: {
    getDetail () {
      const { id } = this;
      this.$http.get('myResearch/auditRecord', {
        params: {
          id
        },
        showLoading: true
      }).then((res) => {
        this.detail = res.data.list || [];
      });
    }
  }
};
</script>

<style lang="less" scoped>
#reviewingRecords {
  padding: 10px 122px 10px 52px;
  .remind {
    display: flex;
    align-items: center;
    margin-bottom: 60px;
    .icon-remind{
      width: 28px;
      height: 28px;
      flex-shrink: 0;
      background-image: url("~@/assets/images/icon_remind_01.png");
    }
    .txt {
      margin-left: 12px;
      font-size: 28px;
      line-height: 48px;
      color: #999AAA;
      opacity: 0.9;
    }
  }
  .box {
    display: flex;
    .line {
      width: 4px;
      background-image: linear-gradient(360deg, #5FA9FF 0%, #5FA9FF 50%, #FFFFFF 100%);
      opacity: 0.5;
      border-radius: 66px;
      flex-shrink: 0;
      margin-right: 52px;
    }
    .list {
      flex: 1;
      padding-top: 10px;
      padding-bottom: 10px;
      .list-item {
        font-size: 28px;
        min-height: 136px;
        background-color: #FFFFFF;
        box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        position: relative;
        padding: 24px;
        &:not(:last-child){
          margin-bottom: 40px;
        }
        &:before{
          content: '';
          width: 28px;
          height: 28px;
          background: url("~@/assets/images/study/icon_annular_01.png") center / contain no-repeat;
          box-shadow: 0px 4px 10px rgba(95, 169, 255, 0.3);
          border-radius: 50%;
          position: absolute;
          left: -54px;
          top: 54px;
          transform: translateX(-50%);
          z-index: 2;
        }
        .top {
          line-height: 40px;
          display: flex;
          margin-bottom: 14px;
          .name{
            color: #666666;
            flex: 1;
          }
          .status{
            font-weight: bold;
            color: #333333;
            flex-shrink: 0;
            margin-left: 10px;
          }
        }
        .bottom{
          display: flex;
          align-items: center;
          .date {
            flex: 1;
            font-size: 24px;
            line-height: 34px;
            color: #999999;
          }
          .btn{
            flex-shrink: 0;
            margin-left: 10px;
            min-width: 140px;
            height: 50px;
            font-size: 24px;
            color: #5FA9FF;
            border: 2px solid #5FA9FF;
            border-radius: 10px;
            padding-left: 20px;
            padding-right: 20px;
          }
        }
        &:last-child:after{
          content: '';
          width: 4px;
          height: 100%;
          background-color: #fff;
          position: absolute;
          left: -56px;
          top: 54px;
          bottom: 0;
        }
      }
    }
  }
}
</style>